import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../slices/authSlice';
import { toast } from 'react-toastify';

// Helper function to decode JWT token
const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

const GoogleCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const refresh = searchParams.get('refresh');

    if (token && refresh) {
      // Decode JWT to get user information
      const decodedToken = decodeJWT(token);
      
      if (decodedToken && decodedToken.sub) {
        const user = {
          id: decodedToken.sub, // Use the actual user ID from JWT
          name: decodedToken.user?.name || 'Google User',
          email: decodedToken.user?.email || 'user@google.com',
          isEmailVerified: decodedToken.user?.isEmailVerified || true
        };

        const tokens = {
          access: { token },
          refresh: { token: refresh }
        };

        dispatch(setCredentials({ user, tokens }));
        toast.success('Successfully signed in with Google!');
        navigate('/dashboard');
      } else {
        toast.error('Invalid token received');
        navigate('/login');
      }
    } else {
      toast.error('Google sign-in failed');
      navigate('/login');
    }
  }, [searchParams, dispatch, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Completing Google sign-in...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
